import Save from '@mui/icons-material/Save'
import { Button, CircularProgress, Dialog, Grid, Typography } from '@mui/material'
import React, { FC, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { filesActions } from 'src/ducks/actions'
import { optionInfo } from './constants'
import InvoiceOption from './InvoiceOption'
import useStyles from './styles'
import { CheckListProps, InvoiceOptionModalProps } from './types'

const InvoiceOptionModal: FC<InvoiceOptionModalProps> = ({
  open,
  setOpen,
  refreshInvoicePDF,
  selectedList,
  setSelectedList,
  isPreliminary,
}) => {
  const styles = useStyles()
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const { id } = useParams()
  const invoiceOptions = useMemo(() => {
    return optionInfo.map((option, index) => ({
      ...option,
      checked: selectedList[index] ?? false,
    }))
  }, [selectedList])

  const handleClickByIndex = (index: number): void => {
    setSelectedList(
      selectedList.map((checked, idx) => (idx === index ? !checked : checked))
    )
  }

  const handleSave = (): void => {
    const newOptions: CheckListProps = invoiceOptions.reduce(
      (prev, { optionCheck, checked }) =>
      ({
        ...prev,
        [optionCheck]: checked,
      } as CheckListProps),
      {}
    )
    setLoading(true)
    dispatch(filesActions.downloadFile({
      documentType: 'INVOICE',
      resourceId: id || '',
      parameters: {
        hidePricing: !newOptions.showPricing,
        hideImages: !newOptions.showImages,
        hideRepairNotes: !newOptions.showRepairNotes,
        showPreliminaryItems: isPreliminary,
      }
    }, (succ: boolean, url?: string) => {
      setLoading(false)
      if (succ && url) {
        window.open(url, '_blank')
      }
    }))
    // refreshInvoicePDF(newOptions)
  }

  const handleClose = (event: React.MouseEvent<HTMLElement>): void => {
    event.preventDefault()

    setSelectedList(selectedList.map(() => true))
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      classes={{
        paper: styles.content,
      }}
      onClose={handleClose}
    >
      <Grid
        container
        direction="column"
        margin={0}
        padding={0}
        style={{
          gap: '20px',
        }}
      >
        <Grid
          item
          container
          direction="column"
          margin={0}
          style={{
            padding: 0,
            gap: '8px',
          }}
        >
          <Typography className={styles.title}>Invoice Options</Typography>
          {invoiceOptions.map((option, index) => (
            <InvoiceOption
              key={index}
              index={index}
              option={option}
              handleClickByIndex={handleClickByIndex}
            />
          ))}
        </Grid>
        <Grid container spacing={1} justifyContent="flex-end">
          <Button
            className={styles.closeButton}
            sx={{ color: '#3A66FF' }}
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className={styles.saveButton}
            endIcon={<Save />}
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} /> : 'Save'}
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default InvoiceOptionModal
